/**
 * Riva — white payment marks
 *
 * Shopify's payment_type_svg_tag emits full-colour brand SVGs: a coloured card
 * "plate" filling the whole viewBox, with the brand mark drawn on top. A CSS
 * filter cannot tell those apart — brightness(0) invert(1) turns the plate white
 * too and you get six blank rectangles.
 *
 * So we do it geometrically instead: any shape that covers most of the SVG is
 * the plate and gets hidden; everything left is the mark and is painted white.
 * That rule is brand-agnostic, which matters because the icon set changes when
 * the merchant enables a new payment method.
 *
 * If this script never runs the icons simply stay in their brand colours —
 * legible and correct, just not monochrome. Failing to white is not worth
 * risking blank payment marks in the footer.
 */
(function () {
  'use strict';

  var PLATE_RATIO = 0.8;   // covers ≥80% of the icon's area → it's the plate
  var SHAPES = 'path, rect, circle, ellipse, polygon, polyline';

  function area(node) {
    try {
      var b = node.getBBox();
      return b.width * b.height;
    } catch (e) {
      return 0; // not rendered yet, or a <defs> child
    }
  }

  function whiten(svg) {
    var total = area(svg);
    if (!total) return false;

    var shapes = svg.querySelectorAll(SHAPES);
    if (!shapes.length) return false;

    Array.prototype.forEach.call(shapes, function (node) {
      // Anything inside <defs> (gradients, clip paths) is never painted directly.
      if (node.closest('defs, clipPath, mask')) return;

      if (area(node) >= total * PLATE_RATIO) {
        node.setAttribute('fill', 'none');
        node.style.fill = 'none';
        if (node.getAttribute('stroke')) {
          node.setAttribute('stroke', 'none');
          node.style.stroke = 'none';
        }
        return;
      }

      node.setAttribute('fill', '#ffffff');
      // The inline style attribute Shopify ships carries fill:color(display-p3 …)
      // which would otherwise win over the attribute.
      node.style.fill = '#ffffff';
      if (node.getAttribute('stroke') && node.getAttribute('stroke') !== 'none') {
        node.setAttribute('stroke', '#ffffff');
        node.style.stroke = '#ffffff';
      }
    });

    return true;
  }

  function run() {
    var wrap = document.querySelector('.subfooter__item--payment');
    if (!wrap || wrap.dataset.rivaWhitened === 'true') return;

    var svgs = wrap.querySelectorAll('svg');
    if (!svgs.length) return;

    var done = 0;
    Array.prototype.forEach.call(svgs, function (svg) {
      if (whiten(svg)) done++;
    });

    // Only claim the treatment once something actually got painted, so a run
    // that fired before layout can be retried.
    if (done === svgs.length) {
      wrap.dataset.rivaWhitened = 'true';
      wrap.classList.add('is-whitened');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  // getBBox returns zeros until the SVG has been laid out; a second pass after
  // load covers the case where the footer was still off-screen or fonts pending.
  window.addEventListener('load', run);
  document.addEventListener('shopify:section:load', run);
})();
